import { ApiOutlined, ReadOutlined } from "@ant-design/icons"
import React from "react"
import { css } from "styled-components"
import { Spacer } from "../atoms/layout-primitives"
import { BlogGrid } from "../atoms/layout-primitives/grid"
import Link from "../atoms/link"
import VariantContainer from "../atoms/variant-container"
import NavBlock from "../molecules/nav-block"

/**
 * SDK link blocks for the blog template pages
 */
const SdkBlocks = () => {
  return (
    <BlogGrid>
      <VariantContainer
        variants={[
          css`
            grid-column: 1/-1;
            display: flex;
            flex-direction: column;
            gap: 24px;
          `,
          css`
            flex-direction: row;
          `,
          css`
            gap: 32px;
          `,
        ]}
      >
        <NavBlock icon={<ReadOutlined />} title="SDK Documentation">
          <Link
            to={
              "https://developer.mappedin.com/web-sdk/latest/getting-started/"
            }
            target="_blank"
          >
            Web
          </Link>
          <Link
            to={
              "https://developer.mappedin.com/react-native-sdk/latest/getting-started/"
            }
            target="_blank"
          >
            React Native
          </Link>
          <Link
            to={"https://developer.mappedin.com/ios-sdk/latest/getting-started"}
            target="_blank"
          >
            iOS
          </Link>
          <Link
            to={
              "https://developer.mappedin.com/android-sdk/latest/getting-started"
            }
            target="_blank"
          >
            Android
          </Link>
        </NavBlock>
        <NavBlock icon={<ApiOutlined />} title="SDK API Reference">
          <Link
            to={"https://developer.mappedin.com/web-sdk-api/latest/"}
            target="_blank"
          >
            Web
          </Link>
          <Link
            to={"https://developer.mappedin.com/react-native-sdk-api/latest/"}
            target="_blank"
          >
            React Native
          </Link>
          <Link
            to={"https://developer.mappedin.com/ios-sdk-api/latest/"}
            target="_blank"
          >
            iOS
          </Link>
          <Link
            to={"https://developer.mappedin.com/android-sdk-api/latest/"}
            target="_blank"
          >
            Android
          </Link>
        </NavBlock>
      </VariantContainer>
      <Spacer height={{ sm: "48px", md: "32px" }} />
    </BlogGrid>
  )
}

export default SdkBlocks
